import gql from "graphql-tag";

import { SUBSCRIPTION_PAGE_NUMBER_FRAGMENT } from "./fragments";

export const SUBSCRIBE_TO_NUMBER_BILLING_SUBSCRIPTION = gql`
  subscription onNumberChanged($numberUuid: ID!) {
    onNumberChanged(numberUuid: $numberUuid) {
      ...SubscriptionPageDetails
    }
  }
  ${SUBSCRIPTION_PAGE_NUMBER_FRAGMENT}
`;
